import { nodeViewDecorators } from "./../../../../ricos-common-plugins/viewer";
import { BreakoutDecorator } from "./breakoutDecorator";
import { Decorators as NodeViewDecorators } from "./nodeViewDecorators";
const decorators = [
  ...nodeViewDecorators,
  BreakoutDecorator
];
var decorators_default = NodeViewDecorators;
export {
  decorators,
  decorators_default as default
};
//# sourceMappingURL=index.js.map
